import dynamic from 'next/dynamic';
import React, { ReactElement } from 'react';

import Layout from '@/components/layouts';
import CustomMetatag from '@/components/layouts/custom-metatag';
// import StrenghtItemCard, {
//   IStrenghtItemCard,
// } from '@/components/sections/lcs/strenght-item-card';
import Feature, {
  IServiceFeature,
} from '@/components/sections/service/feature';
import Header, { IServiceHeader } from '@/components/sections/service/header';
import Intro, { IServiceIntro } from '@/components/sections/service/intro';
import LeasingServiceLineUp, {
  IServiceLineUpProps,
} from '@/components/sections/service/leasing-service-line-up';
import { getHome } from '@/services/contentstack';

const LifeCycle = dynamic(() => import('@/components/sections/life-cycle'), {
  ssr: false,
});

const FooterCVGroup = dynamic(
  () => import('@/components/layouts/cv/footer-group'),
  {
    ssr: false,
  }
);

export async function getStaticProps() {
  const res = await getHome();
  res.data.entry = {
    section_lifecycle: {
      lead: res.data.entry.section_lifecycle.lead,
      title: res.data.entry.section_lifecycle.title,
      description: res.data.entry.section_lifecycle.description,
      items: res.data.entry.section_lifecycle.items.map((o) => ({
        img: {
          url: o.img && o.img.url,
        },
        lead: o.lead,
        title: o.title,
        description: o.description,
        button: o.button,
      })),
    },
  };

  return {
    props: {
      ...res.data,
    },
  };
}

const Page = (props) => {
  const { entry } = props;
  const TITLE = `ตรีเพชรอีซูซุลิสซิ่ง - ISUZU TRUCKS Thailand Official`;
  const DESCRIPTION = 'บริการสินเชื่อเช่าซื้อรถบรรทุกครบวงจร';
  const IMAGE_URL =
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt59262daf140da3de/64900cfd359ef059e860e8e3/og-image.jpg?format=pjpg&auto=webp&width=920&quality=85';

  const HEADER_DATA: IServiceHeader = {
    theme: 'white',
    logo: {
      src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt4a74e94e9867d853/648ac1bd2c4f8741181b123d/logo-isuzu-leasing.svg',
      alt: 'ตรีเพชรอีซูซุลิสซิ่ง',
      width: 250,
      height: 86,
    },
    title: `ตรีเพชรอีซูซุลิสซิ่ง`,
    description: `<p>สินเชื่อรถบรรทุก ต้องอีซูซุลิสซิ่ง</p>`,
  };

  const INTRO_DATA: IServiceIntro = {
    bgColor: 'gray',
    theme: 'green',
    title: `บริการสินเชื่อเช่าซื้อ<span>รถบรรทุกครบวงจร</span>`,
    lead: `อีซูซุลิสซิ่ง`,
    description: `<p>“อีซูซุลิสซิ่ง” พร้อมที่จะให้ คำปรึกษา และให้บริการด้านสินเชื่อรถบรรทุกเพื่อการพาณิชย์สำหรับกลุ่มลูกค้ารายย่อยซึ่งมีธุรกิจขนาดเล็ก ตลอดจนกลุ่มธุรกิจขนาดใหญ่ทุกประเภท ในแบบฉบับของผู้ให้บริการอย่างมืออาชีพภายใต้สโลแกน “มั่นใจอีซูซุ... เลือกอีซูซุลิสซิ่ง”</p>`,
    image: {
      src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb9f4bc0dadd1508d/648bdb75b9a076497f9273ff/isuzuleasing-intro.jpg',
      alt: 'Isuzu Leasing',
      width: 600,
      height: 450,
      priority: true,
    },
  };

  const FEATURE_DATA: IServiceFeature = {
    theme: 'green',
    title: 'รองรับทุกการเติบโตของธุรกิจ',
    imageMobile: {
      src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt259a77931fa5a388/649014f0d2420420d81ccacb/feature-bg-mobile.jpg',
      alt: 'Isuzu Leasing',
      width: 1600,
      height: 1200,
    },
    imageDesktop: {
      src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt47706173614eb290/649014efcc30bb6dd1b0679f/feature-bg-laptop.jpg',
      alt: 'Isuzu Leasing',
      width: 1600,
      height: 900,
    },
    items: [
      {
        icon: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta27fb2d4037ff183/648fcf8b2c4f87b5f61b1cd8/customer.svg',
          alt: 'Icon',
          width: 90,
          height: 90,
        },
        title: 'กลุ่มลูกค้ารายย่อย',
      },
      {
        icon: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltcbfd2a55a1834a70/648fcf8bcc30bb8646b06706/business.svg',
          alt: 'Icon',
          width: 90,
          height: 90,
        },
        title: 'กลุ่มธุรกิจขนาดเล็ก',
      },
      {
        icon: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltef9e078ba6be73b3/648fcf8cd5b9a52dc56dd83a/enterprise.svg',
          alt: 'Icon',
          width: 90,
          height: 90,
        },
        title: 'กลุ่มธุรกิจขนาดใหญ่',
      },
    ],
    buttons: [
      {
        label: 'เข้าชมเว็บไซต์ อีซูซุลิสซิ่ง',
        url: 'https://www.isuzuleasing.com/',
        target: '_blank',
        icon: 'open-in-new',
        iconPosition: 'trailing',
        color: 'button-green',
      },
    ],
  };

  const SERVICE_LINE_UP_DATA: IServiceLineUpProps = {
    title: 'ประเภทรถที่อีซูซุลิสซิ่งให้บริการสินเชื่อ',
    items: [
      {
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blte33cc64900cc34ba/676148704f07d301b2f4071d/euro-5-truck-4-12.png',
          alt: 'รถบรรทุก 4-12 ล้อ (รวมตัวถังและอุปกรณ์)',
          width: 473,
          height: 320,
        },
        label: 'รถบรรทุก 4-12 ล้อ <br/>(รวมตัวถังและอุปกรณ์)',
      },
      {
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blte4b5c54c3b6029f7/67614870579e6c6c90d26e82/euro-5-trailer.png',
          alt: 'รถหัวลาก',
          width: 473,
          height: 320,
        },
        label: 'รถหัวลาก',
      },
      {
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt0a1064abfd939078/6762243c30b2807364df6adc/euro-5-full-trailer.png',
          alt: 'รถพ่วง (Full Trailer)',
          width: 473,
          height: 320,
        },
        label: 'รถพ่วง <br/>(Full Trailer)',
      },
      {
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt2e2aa3d409989fee/67614870e72011dfd80305c0/euro-5-semi-trailer.png',
          alt: 'รถกึ่งพ่วง (Semi Trailer)',
          width: 473,
          height: 320,
        },
        label: 'รถกึ่งพ่วง <br/>(Semi Trailer)',
      },
    ],
  };

  // const STRENGHT_CARD: IStrenghtItemCard = {
  //   title: `โปรโมชันของสินเชื่อ<span>รถบรรทุกจาก</span>`,
  //   remark: `* เงื่อนไขเป็นไปตามที่บริษัทกำหนด`,
  //   logo: {
  //     src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt4a74e94e9867d853/648ac1bd2c4f8741181b123d/logo-isuzu-leasing.svg',
  //     width: 250,
  //     height: 96,
  //   },
  //   items: [
  //     {
  //       logo: {
  //         src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt155bd75b144a6cc5/648c0141c32681099555d591/isuzuleasing-card-calendar.svg',
  //         width: 56,
  //         height: 56,
  //       },
  //       description: `<p>ผ่อนได้นานสูงสุด <br>84 เดือน</p>`,
  //     },
  //     {
  //       logo: {
  //         src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt797dfc0331d5eb37/648c01711fb2d3bcb4495e24/isuzuleasing-down-percent.svg',
  //         width: 56,
  //         height: 56,
  //       },
  //       description: `<p>ดาวน์เริ่มต้น<br>10%</p>`,
  //     },
  //     {
  //       logo: {
  //         src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt91a8b1cae3291d59/648c01a20f2d9bff33ed5aa3/isuzuleasing-steering-wheel.svg',
  //         width: 56,
  //         height: 56,
  //       },
  //       description: `<p>ขับฟรี<br>90 วัน</p>`,
  //     },
  //     {
  //       logo: {
  //         src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt0f52225ca976ddfc/648c01d3ee6549503bccdf1f/isuzuleasing-trip.svg',
  //         width: 56,
  //         height: 56,
  //       },
  //       description: `<p>ฟรี! GPS อัจฉริยะ<br>TELETEC</p>`,
  //     },
  //   ],
  // };

  const SERVICE_STRENGHT: IServiceIntro = {
    dataTestSection: 'section_strength',
    dataTest: 'section_strength',
    dataTrack: 'service-strength',
    bgColor: 'gray',
    title: `จุดเด่นด้านการบริการ ที่ลูกค้าจะได้รับจาก<span>อีซูซุลิสซิ่ง</span>`,
    description: `<ul>
      <li>มีความมั่นคง น่าเชื่อถือ เพราะเป็นบริษัทลิสซิ่งของ<span>กลุ่มตรีเพชร</span></li>
      <li>พื้นที่การให้บริการครอบคลุมทั่วประเทศ</li>
      <li>ให้คำปรึกษาและการบริการอย่างมืออาชีพ</li>
    </ul>`,
    image: {
      src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt99de03c614a1367e/648be75f9601bceeac080fec/isuzuleasing-service-strength.jpg',
      alt: 'Isuzu Leasing Service Strength',
      width: 600,
      height: 450,
    },
    isReverse: true,
  };

  const LIFE_CYCLE_DATA = {
    lead: entry.section_lifecycle.lead,
    title: entry.section_lifecycle.title,
    description: entry.section_lifecycle.description,
    items: entry.section_lifecycle.items.map((o) => ({
      image: {
        src: o.img ? o.img.url : '',
        alt: o.title,
      },
      lead: o.lead,
      title: o.title,
      description: o.description,
      button: o.button,
    })),
  };
  return (
    <>
      <CustomMetatag
        title={TITLE}
        description={DESCRIPTION}
        imgURL={IMAGE_URL}
      />
      <main>
        <Header {...HEADER_DATA} />
        <Intro {...INTRO_DATA} />
        <Feature {...FEATURE_DATA} />
        <LeasingServiceLineUp {...SERVICE_LINE_UP_DATA} />
        {/* <StrenghtItemCard {...STRENGHT_CARD} /> */}
        <Intro {...SERVICE_STRENGHT} />
        <LifeCycle {...LIFE_CYCLE_DATA} />
      </main>
      <FooterCVGroup />
    </>
  );
};

export default Page;

Page.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};
